<template>
  <div id="removeclass">
    <app-modal
      :modal-id="modalId"
      modal-alignment="center"
      modal-size="large"
      @close-modal="closeModal"
      :style="bgStyle && 'background:rgba(0, 0, 0, .5) !important'"
    >
      <template slot="header">
        <h5 class="modal-title">Email Reminder Message</h5>
        <button
          type="button"
          class="close outline-none"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span>
            <app-icon :name="'x'"></app-icon>
          </span>
        </button>
      </template>
      <template slot="body">
        <app-overlay-loader v-if="preloader" />
        <form
          class="mb-0"
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          :data-url="addurl"
        >
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="form-group">
                <label>{{ $t("message") }}</label>
                <app-input
                  type="textarea"
                  :placeholder="$t('enter_message')"
                  v-model="inputs.message"
                  :required="true"
                />
                <p class="text-danger" v-if="show == true">{{error}}</p>
              </div>
            </div>
          </div>
        </form>
      </template>
      <template slot="footer">
        <!-- <button
          type="button"
          class="btn btn-secondary mr-2"
          data-dismiss="modal"
          @click="closeModal"
        >
          {{ $t("close") }}
        </button> -->
        <!-- <button type="button" class="btn btn-primary" @click="submit">
          {{ $t("checkout") }}
        </button> -->
        <app-load-more
                      :preloader="preloader"
                      :label="$t('reminder')"
                      type="submit"
                      class-name="btn btn-primary"
                      @submit="submit"
                    />
      </template>
    </app-modal>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../Mixins/ModalMixin";
import * as actions from "../../../../../Config/ApiUrl";
import { axiosPost, axiosGet } from "../../../../../Helpers/AxiosHelper.js";
import AppLibrary from "../../../../../Helpers/AppLibrary";

export default {
  name: "AddModal",
  extends: AppLibrary,
  mixins: [FormMixin, ModalMixin],
  props: {
    taskId: String,
    type: String,
    bgStyle: Boolean,
  },
  data() {
    return {
      addurl: actions.TASK_REMINDER,
      preloader: false,
      show: false,
      error: '',
      inputs: {},
      modalId: "endorsement-request-send-Modal",
      modalTitle: 'Email Reminder Text',
    };
  },
  //   created() {
  //     if (this.selectedUrl) {
  //       this.modalTitle = this.$t("edit");
  //       // this.postUrl = actions.MYDOCUMENT_UPDATE;
  //       // this.preloader = true;
  //     }
  //   },
  methods: {
    submit() {
      if(this.inputs.message){
        this.preloader = true;
        this.inputs.task_id = this.taskId;
        axiosPost(actions.TASK_REMINDER ,this.inputs)
          .then((res) => {
            this.$toastr.s(res.data.message);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.hideModal();
          });
      }else{
        this.error = 'Please Add Message';
        this.show = true;
      }
    },

    afterSuccess(res) {
      this.preloader = false;
      this.hideModal();
      this.$toastr.s(res.data.message);
      this.$emit("afterSubmitDone");
    },
    afterError() {
      this.preloader = false;
      this.closeModal();
    },
    hideModal() {
      $("#" + this.modalId).modal("hide");
    },
    closeModal() {
      this.hideModal();
      this.$emit("close-modal");
    },
  },

  mounted() {
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
  },
};
</script>
